<template>
	<el-dialog title="快捷短语设置" :visible.sync="visibleProxy" width="640px" append-to-body custom-class="fre-dialog" @open="onOpen" @closed="onClosed">
		<div class="fre-row">
			<div class="fre-label">请输入快捷短语（700字以内）</div>
			<el-input v-model="form.content" type="textarea" :rows="6" maxlength="700" show-word-limit placeholder="" />
		</div>
		<!-- 移除图片上传区域 -->
		<div class="fre-row fre-flex">
			<div class="fre-label">选择分组</div>
			<el-select v-model="form.group" placeholder="请选择" class="fre-group-select">
				<el-option v-for="g in groups" :key="g.id" :label="g.name" :value="g.id" />
			</el-select>
			<el-input v-if="showAddGroup" v-model="newGroup" placeholder="请输入分组名" class="fre-group-input" />
			<el-button v-if="showAddGroup" size="mini" type="primary" @click="addGroup">添加</el-button>
		</div>
		<div class="fre-row">
			<div class="fre-label">快捷编码</div>
			<el-input v-model="form.code" placeholder="字母、数字、中文" class="fre-code-input" />
		</div>
		<div class="fre-tips">
			输入框输入“/”+“快捷编码”或关键字,可以进行搜索。输入数字、↑、↓ 键进行选择，回车键进行确认。
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="visibleProxy = false" :disabled="saving">取消</el-button>
			<el-button type="primary" @click="onConfirm" :loading="saving" :disabled="saving">确认</el-button>
		</span>
	</el-dialog>
</template>

<script>

export default {
	name: 'FastReplyEditorDialog',
	props: {
		visible: { type: Boolean, default: false },
		sceneId: { type: String, default: 0 },
		defaultGroupId: { type: Number, default: null },
		value: { type: Object, default: null },
		showAddGroup: { type: Boolean, default: true }
	},
	data() {
		return {
			form: {
				content: '',
				group: '',
				code: '',
				id: ''
			},
			newGroup: '',
			groups: [],
			saving: false
		};
	},
	computed: {
		visibleProxy: {
			get() { return this.visible; },
			set(v) { this.$emit('update:visible', v); }
		}
	},
	watch: {
		value: {
			immediate: true,
			deep: true,
			handler(v) {
				if (!v) return;
				this.form = {
					content: v.content || '',
					group: v.group || '',
					code: v.code || '',
					id: v.id || ''
				};
			}
		}
	},
	methods: {
		onConfirm() {
			if (this.saving) return;
			const content = (this.form.content || '').trim();
			const code = (this.form.code || '').trim();
			const groupId = this.form.group;
			if (!content) {
				this.$message({ message: '请输入快捷短语', type: 'warning' });
				return;
			}
			if (!groupId) {
				this.$message({ message: '请选择分组', type: 'warning' });
				return;
			}
			if (!code) {
				this.$message({ message: '请输入快捷编码', type: 'warning' });
				return;
			}
			const groupObj = this.groups.find(g => g.id === groupId);
			if (!groupObj) {
				this.$message({ message: '分组无效，请重新选择', type: 'warning' });
				return;
			}
			this.saving = true;
			const data = {
				type: groupObj.type,
				typeid: groupId,
				quicktext: code,
				replytext: content,
			}
			if (this.form.id) data.id = this.form.id;
			this.$http.post(API_ROOT.newcustomer + '/train/reply/saveReply',data).then(res => {
				const result = res.data;
				if (result && result.success) {
					this.$message({
						message: '保存成功',
						type: 'success'
					});
					this.visibleProxy = false;
					this.$emit('refresh');
				} else {
					this.$message({
						message: result.msg,
						type: 'error'
					});
				}
			}, err => {
				this.$message({
					message: '保存失败',
					type: 'error'
				});
			}).finally(() => { this.saving = false; });
		},

		addGroup() {
			if (!this.newGroup) return;
			const self = this;
			this.$http.post(API_ROOT.newcustomer + '/train/reply/saveReplyType?sceneId=' + this.sceneId,{name: this.newGroup}).then(res => {
				const result = res.data;
				if (result && result.success) {
					this.$message({
						message: '保存分组成功',
						type: 'success'
					});
					self.onOpen();
					self.newGroup = '';
				} else {
					this.$message({
						message: result.msg,
						type: 'error'
					});
				}
			}, err => {
				this.$message({
					message: '保存分组失败',
					type: 'error'
				});
			});
		},

		onOpen() {
			this.$http.get(API_ROOT.newcustomer + '/train/reply/searchType?id=' + this.sceneId).then(res => {
				const result = res.data;
				if (result && result.success) {
					this.groups = Array.isArray(result.data.personalType) ? result.data.personalType : [];
					// 如果有默认分组ID，设置为选中状态
					if (this.defaultGroupId && this.groups.some(g => g.id === this.defaultGroupId)) {
						this.form.group = this.defaultGroupId;
					}
				}
			}, err => {
				// 忽略错误，保持现有分组
			});
		},
		onClosed() {
			// 关闭时重置表单内容
			this.form = { content: '', group: '', code: '' };
			this.newGroup = '';
		}
	}
};
</script>

<style lang='less' scoped>
.fre-dialog {
	/deep/ .el-dialog__header {
		background-color: #2d6cf6;
		color: #fff;
		padding: 12px 20px;
	}

	/deep/ .el-dialog__title {
		color: #fff;
		font-weight: 600;
	}

	/deep/ .el-dialog__headerbtn .el-dialog__close {
		color: #fff;
	}

	/deep/ .el-dialog__body {
		padding: 14px 20px;
	}
}

.fre-row {
	margin-bottom: 14px;
}

.fre-label {
	color: #666;
	font-size: 13px;
	margin-bottom: 6px;
}

.fre-uploader {
	width: 100px;
	height: 100px;
	border: 1px dashed #c0c4cc;
	border-radius: 4px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	color: #909399;
	margin-top: 6px;
	position: relative;
}

.fre-uploader .el-icon-plus {
	font-size: 24px;
}

.fre-upload-text {
	margin-top: 6px;
	font-size: 12px;
}

.fre-file {
	display: none;
}

.fre-thumb {
	width: 100px;
	height: 100px;
	background-size: cover;
	background-position: center;
	border-radius: 4px;
	margin-left: 12px;
	display: inline-block;
	vertical-align: top;
	position: relative;
}

.fre-thumb-actions {
	position: absolute;
	right: 6px;
	top: 6px;
	background: rgba(0,0,0,0.45);
	border-radius: 50%;
	width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	cursor: pointer;
}

.fre-flex {
	display: flex;
	align-items: center;
}

.fre-group-select {
	width: 180px;
	margin-left: 10px;
}

.fre-group-input {
	width: 180px;
	margin: 0 10px;
}

.fre-code-input {
	width: 260px;
}

.fre-tips {
	color: #909399;
	font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// ./src/page/train/FBT/components/FastReplyEditorDialog.vue